module.exports = __webpack_public_path__ + "media/BNP_Samodzielniak_17_G_2.f7a08ca0.mp3";